let Table = mc.widgets.Table;
let Orderable = mc.widgets.Orderable;
let IconButton = mc.widgets.IconButton;
let FormControls = mc.widgets.FormControls;

let DiaryFormView = require("../view/DiaryFormView");

let StudyDiariesList = function (props) {
  let cols = [
    {
      prop: "displayName",
      label: tx("name"),
      content: function (diary) {
        let editDiary = function () {
          DiaryFormView.open(diary, props.disabled || diary.pipelineIds.length > 0);
        };

        return <a onClick={editDiary}>{diary.displayName}</a>;
      },
      width: "35%",
      sort: false
    },
    {
      prop: "questions",
      label: tx("questions"),
      content: function (diary) {
        return diary.questions.map((q) => q.text).join("; ");
      },
      width: "60%",
      sort: false,
      clip: true
    },
    {
      prop: "copy",
      label: "",
      content: function (diary) {
        return (
          <IconButton
            icon="copy"
            label={tx("copy")}
            onPress={() => props.onCopy(diary)}
            scale={0.9}
            disabled={props.disabled || diary.pipelineIds.length > 0}/>
        );
      },
      width: "5%",
      sort: false
    }
  ];

  return <Table data={props.diaries} cols={cols} align="middle"/>;
};

let OrderableRow = function (props) {
  return (
    <div key={props.id}>
      {props.displayName}
    </div>
  );
};

let StudyDiariesForm = function (props) {
  let rows = props.diaries.filter((a) => a.mode === "SUPERVISED").map(function (diary) {
    return <OrderableRow key={diary.id} orderId={diary.id} displayName={diary.displayName}/>;
  });

  return (
    <div>
      <p>{tx("arrange_diaries")}</p>
      <Orderable onOrder={props.onOrder}>
        {rows}
      </Orderable>
    </div>
  );
};

class StudyDiaries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: [],
      submitting: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.editing !== this.props.editing && this.props.editing === true) {
      this.setState({
        order: this.props.diaries.map((diary) => diary.id),
        submitting: false
      });
    }
  }

  cancel() {
    this.props.onCancel();
  }

  save() {
    this.setState({
      order: [],
      submitting: true
    });

    this.props.onSave(this.order(this.props.diaries));
  }

  reorder(order) {
    this.setState({ order });
  }

  order(diaries) {
    return this.state.order.map(function (orderId) {
      return diaries.find((diary) => diary.id === orderId);
    });
  }

  render() {
    let component = <StudyDiariesList {...this.props}/>;
    let diaries;

    if (this.props.editing) {
      diaries = this.order(this.props.diaries);

      component = (
        <div>
          <StudyDiariesForm
            diaries={diaries}
            onOrder={this.reorder.bind(this)}/>
          <FormControls
            onSave={this.save.bind(this)}
            onCancel={this.cancel.bind(this)}
            enabled={!this.state.submitting}/>
        </div>
      );
    }

    return component;
  }
}

module.exports = StudyDiaries;
